// Экран «Справка» («Как считаются сроки») — семнадцатый экран нового фронта
// (п.20, 2026-09-07). Текст статический и живёт отдельным файлом `src/wiki.html`,
// перенесённым из оболочки дословно: правится он вместе с ядром (правило CLAUDE.md
// «правишь ядро — правь вики в том же коммите»), поэтому держим его одним куском,
// а не переписываем в разметку компонента.
import wiki from '../wiki.html?raw';

export function Wiki() {
  // id обязателен: на нём висят все стили вики в app.css (#view-wiki …) — ширина
  // колонки 920 px, таблицы, рамки примеров и предупреждений. При переезде на новый
  // фронт (п.20, 2026-09-07) id потерялся, и справка полгода рисовалась без стилей:
  // таблицы растягивались на 2276 px и уводили текст за край экрана (найдено
  // автопрогоном читаемости 2026-09-30).
  // содержимое своё, не пользовательское — вставляем как есть
  return <div id="view-wiki" dangerouslySetInnerHTML={{ __html: wiki }} />;
}
